/**
 * Formats minutes from midnight as a 12-hour time string.
 * e.g. 540 → "9:00 am", 780 → "1:00 pm", 0 → "12:00 am"
 *
 * @param {number|null} minutes - Minutes from midnight (0–1439)
 * @param {Object} options - Formatting options
 * @param {boolean} options.showMinutes - Whether to show minutes (default: true)
 * @param {boolean} options.showSuffix - Whether to show am/pm suffix (default: true)
 * @returns {string} Formatted time string, or empty string for null input
 */
export default function formatMinutesAsTime(minutes, { showMinutes = true, showSuffix = true } = {}) {
  if (minutes == null) {
    return '';
  }
  const m = minutes % 1440;
  const h = Math.floor(m / 60);
  const min = Math.floor(m % 60);
  const ampm = h >= 12 ? 'pm' : 'am';
  const h12 = h % 12 || 12;

  let result = `${h12}`;

  if (showMinutes) {
    result += `:${min.toString().padStart(2, '0')}`;
  }
  if (showSuffix) {
    result += ` ${ampm}`;
  }

  return result;
}
